export function stateToModel(medicalConsent) {
  let medicalConsentModel = {
    LeadMemberName: medicalConsent.fullName,
    claimNumber: medicalConsent.claimNumber,
    LeadMemberAddress: medicalConsent.address,
    phoneNumber: medicalConsent.phoneNumber,
    membershipNumber: medicalConsent.membershipNumber,
    TreatmentAsAResultOfAnAccident:
      medicalConsent.areYouHavingTreatment === "yes",
    TreatmentNeededAsAResultOfMedicalNegligence:
      medicalConsent.isTheTreatmentNeeded === "yes",
    OtherInsurancePoliciesResponsibleForShareOfCost:
      medicalConsent.doYouHaveOtherPolicies === "yes",
    OtherInsuranceProviderName: medicalConsent.otherInsuranceCompanyName,
    OtherInsuranceProviderAddress: medicalConsent.otherInsuranceCompanyAddress,
    OtherInsuranceProviderPolicyNumber: medicalConsent.otherPolicyNumber,
    ConsentToReviewMyClaimAndApplyPolicyTerms:
      medicalConsent.assessAndReview === "yes",
    ConsentToAuditHealthcarePractitioner:
      medicalConsent.auditHealthcare === "yes",
    IAmThePatient: medicalConsent.iAmThePatient === "yes",
    PatientName: medicalConsent.patientName,
    PatientIsUnder16: medicalConsent.isPatientUnder16 === "yes",
    RelationshipToPatient: medicalConsent.relationshipToPatient,
    IAmThePatientsParent: medicalConsent.isPatientsParent === "yes",
    WishToSeeReportFromMedicalPractitioner: medicalConsent.seeReport === "yes",
    AcceptTermsOutlinedInTheImportantInformation:
      medicalConsent.acceptTermsAndConditions === "yes"
  };

  return medicalConsentModel;
}
